<template>
  <!-- Индикатор «Проблема с сетью» (App.vue, поверх всего приложения).
       Эпизод обрыва: флаг store.network.problem взводит response-interceptor,
       первый успешный запрос снимает его сам. На первый обрыв всплывает диалог;
       «Закрыть» переводит в тихий баннер до конца эпизода. «Повторить»
       ремаунтит текущий роут (обработчик в App.vue). -->
  <div>
    <v-dialog :value="dialogOpen" max-width="420" @input="onDialogInput">
      <v-card>
        <v-card-text class="text-center pt-8 pb-0">
          <img :src="catImg" width="160" alt="" />
          <p class="text-h6 mt-4 mb-2">{{ $t("errors.network_problem_title") }}</p>
          <p class="mb-0">{{ $t("errors.load_failed_network") }}</p>
        </v-card-text>
        <v-card-actions class="justify-center pb-6 pt-4">
          <v-btn text @click="dismiss">{{ $t("custom.close") }}</v-btn>
          <v-btn color="primary" @click="retry">
            <v-icon left>mdi-refresh</v-icon>
            {{ $t("custom.retry") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-banner v-if="bannerVisible" single-line sticky class="network-banner">
      <img :src="catImg" class="network-banner-cat mr-2" height="44" alt="" />
      {{ $t("errors.network_problem") }}
      <template v-slot:actions>
        <v-btn color="primary" text @click="retry">
          <v-icon left>mdi-refresh</v-icon>
          {{ $t("custom.retry") }}
        </v-btn>
      </template>
    </v-banner>
  </div>
</template>

<script>
import catImageMixin from "@/mixins/catImageMixin";

export default {
  name: "NetworkProblem",
  mixins: [catImageMixin],
  data() {
    return {
      dialogOpen: false,
      dismissed: false,
    };
  },
  computed: {
    problem() {
      return this.$store.state.network.problem;
    },
    // Страница заявила, что объясняет сетевой отказ сама — индикатор молчит
    // целиком (и модалка, и баннер): дублировать одну ошибку в трёх местах с
    // двумя разными «Повторить» человеку только мешает. Заявка живёт всю
    // попытку загрузки, поэтому переживает нажатие «Повторить» на странице.
    pageHandled() {
      return this.$store.state.network.loadClaims.length > 0;
    },
    bannerVisible() {
      return this.problem && this.dismissed && !this.pageHandled;
    },
  },
  watch: {
    problem: {
      immediate: true,
      handler(value) {
        if (value) {
          this.openDialogIfOurs();
        } else {
          this.dialogOpen = false;
          this.dismissed = false;
        }
      },
    },
    // Флаг страницы мог подняться ПОСЛЕ модалки: интерсептор взводит problem в
    // том же тике, в котором карточка только собирается отрисовать свой блок.
    pageHandled(value) {
      if (value) {
        this.dialogOpen = false;
        return;
      }
      // Падающий фронт обязателен (находка ревью 18.09.2026). Страница со своим
      // блоком ушла, а сеть всё ещё лежит: problem не менялся — его watcher не
      // сработает, и повторный SET_PROBLEM(true) с тем же значением тоже
      // (реактивный сеттер короткозамыкается). Без этой ветки индикатора не было
      // бы НИГДЕ до конца эпизода: «одна ошибка — одно место» превратилось бы в
      // ноль мест, а тосты транзиентных ошибок подавлены намеренно
      // (setErrorMixin) именно в расчёте на индикатор.
      //
      // Спрашивать про problem обязательно: заявка снимается и на УСПЕХЕ
      // загрузки — обычный путь каждой карточки при исправной сети. Без этой
      // проверки модалка «Проблема с сетью» всплывала бы на каждом открытии
      // карточки (блокер финального ревью 21.09.2026).
      if (this.problem) {
        this.openDialogIfOurs();
      }
    },
  },
  methods: {
    // Ждать нечего: страница заявляется в начале загрузки, то есть РАНЬШЕ, чем
    // интерсептор увидит отказ. Прежняя пауза в 250 мс существовала лишь потому,
    // что заявку делал компонент — на рендер позже события.
    openDialogIfOurs() {
      if (this.dismissed || this.pageHandled) return;
      this.dialogOpen = true;
    },
    dismiss() {
      this.dialogOpen = false;
      this.dismissed = true;
    },
    // Клик мимо диалога / esc — считаем за «Закрыть»
    onDialogInput(value) {
      if (!value) {
        this.dismiss();
      }
    },
    retry() {
      this.$emit("retry");
    },
  },
};
</script>

<style scoped>
.network-banner-cat {
  vertical-align: middle;
}
</style>
